import VehicleCategory from '@/types/vehicle-category';
import {
  buildEventBase,
  EventBaseOptions, extraIdentifierToReadable,
  fireAppsflyerEvent,
} from '@rental/prebooking-ui-utils';
import {IDENTIFIERS} from "@/config/extras";

export const pushToDataLayer = (event: any) => {
  window.dataLayer ? window.dataLayer.push(event) : window.dataLayer = [event];
};

/**
 * Pushes a GA4 event to the dataLayer
 * @param eventName The name of the event
 * @param eventParams Additional parameters for the event
 */
export const pushGA4Event = (eventName: string, eventParams: Record<string, any> = {}) => {
  pushToDataLayer({
    event: "ga4_event",
    event_name: eventName,
    ...eventParams
  });
};

/**
 * Tracks a form step view in GA4
 * @param stepName The name of the form step (e.g., "trip", "category")
 * @param additionalParams Additional parameters to include in the event
 */
export const trackFormStepView = (stepName: string, additionalParams: Record<string, any> = {}) => {
  pushGA4Event(`prebooking_${stepName}_page_view`, {
    form_step: stepName,
    page_path: window.location.pathname,
    page_title: document.title,
    page_location: window.location.href,
    ...additionalParams
  });
};

const extrasToObject = (extras: string[]) => ({
  comfort_package: extras.includes(IDENTIFIERS.COFFEE),
  cross_border: extras.includes(IDENTIFIERS.ARROWS),
  additional_driver: extras.includes(IDENTIFIERS.ADDITIONAL_DRIVER),
})

interface BookingSuccessEventOptions extends EventBaseOptions {
  prebooking_id: string;
  price: number;
  currency: string;
  prebooking_vehicle_category: VehicleCategory;
  prebooking_insurance: string | undefined;
  prebooking_extras: string[];
  prebooking_new_user: boolean;
  prebooking_mileage: number;
  uuid?: string
}
export const pushBookingSuccessEvent = (options: BookingSuccessEventOptions) =>
  pushToDataLayer({
    ...buildEventBase(options),
    event: 'ce_prebooking_success',
    event_category: 'prebooking',
    event_action: 'prebooking_success',
    prebooking_id: options.prebooking_id,
    price: options.price,
    currency: options.currency,
    prebooking_vehicle_category: options.prebooking_vehicle_category,
    prebooking_insurance: options.prebooking_insurance ? extraIdentifierToReadable(options.prebooking_insurance) : undefined,
    prebooking_extras: extrasToObject(options.prebooking_extras),
    prebooking_new_user: options.prebooking_new_user,
    prebooking_mileage: options.prebooking_mileage,
  });

export const handleShareNowBookingSuccess = (options: BookingSuccessEventOptions) => {
  fireAppsflyerEvent(window, 'prebook_form_complete');
  pushBookingSuccessEvent(options);
};

export const handleMbRentBookingSuccess = (options: BookingSuccessEventOptions) => {
  pushBookingSuccessEvent(options);
};
